import { render } from "./dermatology_examination.vue?vue&type=template&id=6f28b72a&scoped=true"
import script from "./dermatology_examination.vue?vue&type=script&lang=js"
export * from "./dermatology_examination.vue?vue&type=script&lang=js"

import "./dermatology_examination.vue?vue&type=style&index=0&id=6f28b72a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f28b72a"]])

export default __exports__